export const ELEMENT_TYPE = [
  { label: 'Unordered', value: 'ul' },
  { label: 'Ordered', value: 'ol' },
  { label: 'Pros & Cons', value: 'prosAndCons' },
  { label: 'Rewards', value: 'rewardsRates' },
  { label: 'Marketing Bullets', value: 'marketingBullets' },
  { label: 'Personal Loans', value: 'personalLoans' },
] as const;
export type ElementType = (typeof ELEMENT_TYPE)[number]['value'];

export const BULLET_LIST_STYLE_TYPE = [
  { label: 'Dot', value: 'disc' },
  { label: 'Dash', value: 'dash' },
  { label: 'Custom', value: 'imageUrl' },
  { label: 'None', value: 'none' },
] as const;
export type BulletListStyle = (typeof BULLET_LIST_STYLE_TYPE)[number]['value'];

export type BulletListItem = {
  id: string;
  customListMarker?: string;
  text?: string;
  italic?: boolean;
  fontSize?: number;
  color?: string;
};
